/**
 * Mega Menu Hover Activation
 * Opens mega menu on hover instead of click (desktop only)
 */

document.addEventListener('DOMContentLoaded', () => {
  let currentOpenMenu = null;
  let closeTimeout = null;

  document.querySelectorAll('header-menu details.mega-menu').forEach(details => {
    const parent = details.closest('li');

    if (parent) {
      parent.addEventListener('mouseenter', () => {
        // Clear any pending close
        if (closeTimeout) {
          clearTimeout(closeTimeout);
          closeTimeout = null;
        }

        // If another menu is open, close it immediately and open this one
        if (currentOpenMenu && currentOpenMenu !== details) {
          currentOpenMenu.open = false;
        }

        // Open current menu
        details.open = true;
        currentOpenMenu = details;
      });

      parent.addEventListener('mouseleave', () => {
        // Delay the close slightly to avoid the gap when moving between menus
        closeTimeout = setTimeout(() => {
          details.open = false;
          if (currentOpenMenu === details) {
            currentOpenMenu = null;
          }
        }, 50);
      });
    }
  });
});
